import script from "./AuthRegister.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthRegister.vue?vue&type=script&setup=true&lang=js"

import "./AuthRegister.vue?vue&type=style&index=0&id=63c3214d&lang=css"
import "./AuthRegister.vue?vue&type=style&index=1&id=63c3214d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63c3214d"]])

export default __exports__